import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const PAGE_SIZE_OPTIONS = [20, 30, 40, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;

interface PaginationProps {
  page: number;
  pageSize: number;
  count: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  page,
  pageSize,
  count,
  onPageChange,
  onPageSizeChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(count / pageSize));
  const from = count === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, count);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 py-3 px-4 border-t border-gray-100">
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <span>Sahifada:</span>
        <select
          className="input !py-1 !w-auto"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <span className="whitespace-nowrap">
          {from}-{to} / {count} ta
        </span>
      </div>

      <div className="flex items-center gap-2">
        <button
          className="btn btn-secondary flex items-center gap-1"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft size={16} />
          <span>Oldingi</span>
        </button>
        <span className="px-2 text-gray-600 text-sm whitespace-nowrap">
          {page} / {totalPages}
        </span>
        <button
          className="btn btn-secondary flex items-center gap-1"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          <span>Keyingi</span>
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};
